export default {
  getFilters: state => state.filters
}
